import type { ApiError, Identifiable } from '@empathyco/playboard-core-domain'
import type { BrowseFacetDTO, BrowseFacetType, BrowseFacetValueDTO } from '../models'
import type { BrowseFacetAdapter } from './interfaces'
import { injectable } from 'inversify'

export interface PlatformBrowseFacetEntity {
  facet: string
  label: string
  filter: string
  type: BrowseFacetType
  values: Array<PlatformBrowseFacetValue>
}

interface PlatformBrowseFacetValue extends Identifiable {
  value: string
  count: number
  filter: string
}

export interface PlatformBrowseFacetError {
  status: number
  data?: any
}

@injectable()
export class PlatformBrowseFacetAdapter implements BrowseFacetAdapter<PlatformBrowseFacetEntity> {
  decode(payload: PlatformBrowseFacetEntity): BrowseFacetDTO {
    const { facet, label, type, values, filter } = payload ?? {}
    return {
      id: facet,
      label,
      filter,
      type,
      values: values?.map(value => this.decodeValue(value)) ?? [],
    }
  }

  decodeError(error: PlatformBrowseFacetError): ApiError {
    return {
      status: error.status,
    }
  }

  private decodeValue(payload: PlatformBrowseFacetValue): BrowseFacetValueDTO {
    const { id, value, count, filter } = payload
    return {
      id,
      value,
      count,
      filter,
    }
  }
}
